import { APP_BASE_HREF, Location } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  ViewChild,
  Output,
  OnDestroy,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { ResponseHandler } from '@app/_core/helper/ResponseHandler';
import { Utils } from '@app/_core/helper/Utils';
import { AppService } from '@app/_core/services/app.service';
import { AuditorService } from '@app/_core/services/auditor.service';
import { ConsoleService } from '@app/_core/services/console.service';
import { ExcelService } from '@app/_core/services/excel.service';
import { ManagerService } from '@app/_core/services/manager.service';
import { QueuesService } from '@app/_core/services/queues.service';
import { SecurityService } from '@app/_core/services/security.service';
import { WebStorageService } from '@app/_core/services/webstorage.service';
import { ConfirmDialogComponent } from '@app/pages/common/confirm-dialog/confirm-dialog.component';
import { saveAs as fileSaverSave } from 'file-saver';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { lastValueFrom } from 'rxjs';
import { json } from 'stream/consumers';
import { object } from 'underscore';

@Component({
  selector: 'app-interaction-details',
  templateUrl: './interaction-details.component.html',
  styleUrls: ['./interaction-details.component.scss'],
})
export class InteractionDetailsComponent implements OnInit, OnDestroy {
  public event: EventEmitter<any> = new EventEmitter();
  auditSaved: boolean = false;
  audioSource = '';

  @Input() ID: number;
  @Input()
  queueList: any;
  @Input()
  isAuditor: any = false;
  @Input()
  isManager: any = false;
  @Input()
  isStaffer: any = false;
  @Input()
  isReporter: any = false;
  @Input()
  isCloseable: any;
  @Input()
  interactionId: string = '';
  @Input()
  isPerformance: any = false;
  @Input()
  surveyForm: string = '';
  @Input()
  recentInteractions: boolean = false;
  @Output() OnHide: EventEmitter<any> = new EventEmitter();
  @Input() hasAudits: boolean = false;
  hdrText: string = '';
  btnText: string = '';
  lists: any = [];
  companyCode: any = '';
  clientAbbreviation: any = '';
  interactionDetailedData: any;
  userDetails: any;
  recordingPageNo = 1;
  recordingStatus: boolean = true;
  public recordingDetails: any;
  recordingfile: any;
  @ViewChild('audioPlayer') audioPlayer!: ElementRef<HTMLAudioElement>;
  recordingRes: any;
  isRecordLoaded: boolean = false;
  categories: any;
  isSubmitted: boolean = false;
  showAudit: boolean = false;
  auditData: any;
  auditDetails: any;
  filteredAuditArray: any[];
  selectedForm: any;
  selectedType: any;

  auditSurveyForm: FormGroup;
  surveySections: any;
  selectedFieldOption: any;
  selectedTypeArray: any;
  selectedSurveyArray: any;
  newSurveyData: any;
  scoreValueArray: any[] = [];
  scoreValue: any;
  selectedOption: string;
  fieldOptions: any;
  selectedFormFieldOption: any[] = [];
  sectionLabelStatus: string;
  showPoints: boolean = true;
  // zeroPoints: boolean = true;

  checkStatusArray: any[] = [];
  selectedSurvey: any;
  showOpenSurvey: boolean;
  ivrTime: any;
  queueTime: string;
  csrTime: string;
  submittedDate: string;
  startedDate: string;
  queuedDate: string;
  answeredDate: string;
  endedDate: string;
  followUpDate: string;
  updatedSectionsArray: any[] = [];
  saveSectionData: any[] = [];
  surveyPermissions: any;
  surveyID;
  surveyActionID;
  surveyTypeID;
  surveyDefinitionID;
  savedSurveyId;
  saveLabel: any;
  showSaveBtn: boolean = false;
  showSubmitBtn: boolean = false;
  showDeleteBtn: boolean = false;
  showExportBtn: boolean = false;
  status: boolean;
  savedSurveyRes: any;
  submitLabel: any;
  DeleteLabel: any;
  deleteLabel: any;
  exportLabel: any;
  openAuditResponse: boolean;

  emptySurveys: any;
  emptySections: any;
  showComments: boolean;
  textContent: string = '';

  showAudioTab: boolean = false;
  saveCommentData: any;

  isDeleted: boolean = false;
  savedCommentID: any;
  FieldResponseCommentID: any;
  newName: string;
  showSurveyDetails: boolean;
  recordingsArray: any[] = [];
  selectedRecordingValue: any;
  modalRef?: BsModalRef;
  isChecked: any;
  checkCommentsLength: number = 0;
  showRecOptions: boolean = false;
  userEmail: any;
  surveyUserEmail: any;
  hasAuditSurvey: any = null;
  isAudit: boolean = false;
  videoRecordingfile: any;
  videoSource: string = '';
  isVideoRecordLoaded: boolean = false;
  videoRecordingsArray: any = [];
  selectedVideoRec: any;
  showVideoRecOptions: boolean = false;
  showVideoTab: any = false;
  interactionUserData: any;
  interactionUserDataKeys: string[] = [];
  isTranscript: boolean = false;
  isSameAgent: boolean = false;
  recordingTab = [
    { name: 'AgentDesktop', label: 'Agent Desktop', isSelected: true, index: 0, show: true },
    { name: 'Audio', label: 'Audio', isSelected: false, index: 1, show: true },
  ];
  selectedTab: string = '';
  showHeader: boolean;
  isNewDisabled: boolean;
  isDeletedSurvey: boolean;
  auditTypes: any = [];
  auditDefinations: any = [];
  existingSurvey: any;
  duplicateSavedSurveyId: any;
  filename: string = '';
  audiofilename: string = '';
  noGrantAuditView: boolean = false; // hasAudits && !isAuditor
  @Input() liveStatusesAudit: boolean = false;
  allowViewSurvey: boolean = false;
  showSurveyRightPanel: boolean = false;
  saveSurveyTimeout: any
  newAuditSurveyTimeout: any;
  closeTaskMenuTimeout: any;
  IsCompliance: boolean = false;
  constructor(
    private location: Location,
    private securityService: SecurityService,
    private utils: Utils,
    private excelService: ExcelService,
    public bsModalRef: BsModalRef,
    private router: Router,
    private queueService: QueuesService,
    private appService: AppService,
    private webStorageService: WebStorageService,
    private auditorService: AuditorService,
    private managerService: ManagerService,
    private modalService: BsModalService,
    private consoleService: ConsoleService,
    @Inject(APP_BASE_HREF) public baseHref: string,
    private cd: ChangeDetectorRef
  ) { }

  async ngOnInit(): Promise<void> {
    this.isPerformance = this.isPerformance === true || this.isPerformance === 'true';
    this.isAudit = this.securityService.validateGrant('AuditAgents');
    this.isAuditor = this.securityService.validateGrant('AuditAgents');
    
    if (this.liveStatusesAudit) 
      {
      this.isAudit = true;
      //this.isAuditor = true;
      }
     else if (this.isPerformance) 
      {
       this.isAudit = true;
       //this.isAuditor = true;
      }
      else if (this.hasAudits) 
      {
        this.isAudit = true;
       // this.isAuditor = true;
      }
    //this.noGrantAuditView = this.hasAudits && !this.isAuditor;
    this.noGrantAuditView = (this.hasAudits || this.liveStatusesAudit) && !this.isAuditor;
    if ((this.isAudit == true || this.isAudit == false) && this.recentInteractions == true) {
      this.isAudit = false;
    } else if (this.isAudit == true && this.recentInteractions == false) {
      this.isAudit = true;
    } else if (this.isAudit == false) {
      this.isAudit = false;
    }
    let user = this.webStorageService.getItemFromSessionStorage('currentUser');
    let company = this.webStorageService.getItemFromSessionStorage('company');
    const uc = { interactionID: this.interactionId, company: company, user: user };
    this.companyCode = localStorage.getItem('companyCode');
    await this.checkAuditSurveyExperience();
    // if (this.hasAuditSurvey == true) {
    //   this.showAudit = true;
    // } else if (this.hasAuditSurvey == false) {
    //   this.showAudit = false;
    // }

    //console.log(this.showAudit);
    //console.log(this.isAudit);
    this.clientAbbreviation = Utils.fetch('clientAbbreviation');
    //console.log(this.clientAbbreviation);
    //console.log(uc);

    // if (this.clientAbbreviation == 'LCP' || this.clientAbbreviation == 'CAC') {
    //   this.showAudit = true;
    // } else if (this.clientAbbreviation == 'QA1') {
    //   this.showAudit = false;
    // }

    this.getAuditDetailsByInteractionId(this.interactionId);
    const res: any = await lastValueFrom(this.auditorService.GetInteractionsDetailById(uc));
    // this.auditorService.GetInteractionsDetailById(uc).subscribe(async res=>{
    if (res) {
      this.interactionDetailedData = res.Response.Data;
      this.interactionUserData = res.Response.Data.UserData;
      this.isTranscript = this.interactionDetailedData.EnablePostCallView;
      if (typeof this.interactionUserData === 'string') {
        this.interactionUserData = JSON.parse(this.interactionUserData);
      }
      if (
        this.interactionUserData &&
        typeof this.interactionUserData === 'object' &&
        !Array.isArray(this.interactionUserData)
      ) {
        this.interactionUserDataKeys = Object.keys(this.interactionUserData);
        this.interactionUserDataKeys = this.interactionUserDataKeys.filter(key => key !== 'Industry');

      }

      if (this.isTranscript) this.appService.SetTranscriptId(this.interactionId, false);

      // this.interactionDetailedData.Submitted = this.utils.convertServerDate(this.interactionDetailedData.Submitted);
      // this.interactionDetailedData.Started = this.utils.convertServerDate(this.interactionDetailedData.Started);
      // this.interactionDetailedData.Queued = this.utils.convertServerDate(this.interactionDetailedData.Queued);
      // this.interactionDetailedData.Answered = this.utils.convertServerDate(this.interactionDetailedData.Answered);
      // this.interactionDetailedData.Ended = this.utils.convertServerDate(this.interactionDetailedData.Ended);
      // this.interactionDetailedData.FollowUpDate = this.utils.convertServerDate(this.interactionDetailedData.FollowUpDate);

      this.interactionDetailedData.HandlingTime =
        this.interactionDetailedData.HandlingTime > 0
          ? this.utils.formatDuration(this.interactionDetailedData.HandlingTime, '', '', '', '')
          : '-';
      this.interactionDetailedData.TotalHoldTime = this.interactionDetailedData.TotalHoldTime
        ? this.utils.formatDuration(this.interactionDetailedData.TotalHoldTime, '', '', '', '')
        : '-';

      this.queueTime = this.interactionDetailedData.Queued
        ? this.utils.formatDuration(
          (Date.parse(this.interactionDetailedData.Answered) || Date.parse(this.interactionDetailedData.Ended)) -
          Date.parse(this.interactionDetailedData.Queued),
          'ms',
          '',
          '',
          ''
        )
        : '-';

      this.ivrTime =
        (this.interactionDetailedData.InteractionType == 'InboundCall' && (this.interactionDetailedData.Queued != null || this.interactionDetailedData.Answered != null))
          ? this.utils.formatDuration(
            (Date.parse(this.interactionDetailedData.Queued) || Date.parse(this.interactionDetailedData.Answered)) -
            Date.parse(this.interactionDetailedData.Started),
            'ms',
            '',
            '',
            ''
          )
          : '-';
      this.csrTime =
        this.interactionDetailedData.InteractionType == 'InboundCall'
          ? this.interactionDetailedData.Answered
            ? this.utils.formatDuration(
              (Date.parse(this.interactionDetailedData.Submitted) > Date.parse(this.interactionDetailedData.Ended)
                ? Date.parse(this.interactionDetailedData.Ended)
                : Date.parse(this.interactionDetailedData.Submitted)) -
              Date.parse(this.interactionDetailedData.Answered),
              'ms',
              '',
              '',
              ''
            )
            : '-'
          : this.utils.formatDuration(
            (Date.parse(this.interactionDetailedData.Submitted) > Date.parse(this.interactionDetailedData.Ended)
              ? Date.parse(this.interactionDetailedData.Ended)
              : Date.parse(this.interactionDetailedData.Submitted)) -
            Date.parse(this.interactionDetailedData.Started),
            'ms',
            '',
            '',
            ''
          );

      this.submittedDate = this.interactionDetailedData.Submitted
        ? this.utils.GetESTtoLocalTimeZone(this.interactionDetailedData.Submitted)
        : '-';
      this.startedDate = this.interactionDetailedData.Started
        ? this.utils.GetESTtoLocalTimeZone(this.interactionDetailedData.Started)
        : '-';
      this.queuedDate = this.interactionDetailedData.Queued
        ? this.utils.GetESTtoLocalTimeZone(this.interactionDetailedData.Queued)
        : '-';
      this.answeredDate = this.interactionDetailedData.Answered
        ? this.utils.GetESTtoLocalTimeZone(this.interactionDetailedData.Answered)
        : '-';
      this.endedDate = this.interactionDetailedData.Ended
        ? this.utils.GetESTtoLocalTimeZone(this.interactionDetailedData.Ended)
        : '-';
      this.followUpDate = this.interactionDetailedData.FollowUpDate
        ? this.utils.GetESTtoLocalTimeZone(this.interactionDetailedData.FollowUpDate)
        : '-';

      if (this.interactionDetailedData?.Recording && this.interactionDetailedData?.VideoRecording) {
        this.showHeader = true;
        this.selectedTab = 'AgentDesktop';
      } else {
        this.showHeader = false;
      }

      //Audio Recording
      this.recordingfile = this.interactionDetailedData.Recording;
      if (this.recordingfile != null && this.recordingfile.includes('|')) {
        this.recordingsArray = this.recordingfile.split('|');
        //console.log(this.recordingsArray);

        this.recordingsArray = this.recordingsArray.filter(item => item);
        this.selectedRecordingValue = this.recordingsArray[0];
        //console.log(this.selectedRecordingValue);
      } else {
        this.selectedRecordingValue = this.recordingfile;
        this.showRecOptions = false;
      }

      if (this.recordingfile != null && this.recordingfile.length > 0) {
        this.showAudioTab = true;
        this.showRecOptions = true;
        // console.log(this.recordingfile);
        const data = await lastValueFrom(this.managerService.getRecordingFiles(this.selectedRecordingValue));
        // console.log(data);
        if (data) {
          this.selectedTab = this.showHeader ? this.selectedTab : 'Audio';
          this.loadAudioClick(data);
          this.isRecordLoaded = true;
        }
      }

      //Video Recording
      if (this.interactionDetailedData) {
        let videoRecordingPath = this.interactionDetailedData.VideoRecording;
        if (videoRecordingPath && videoRecordingPath.length > 0) {
          this.showAudioTab = true;
          this.videoRecordingsArray = videoRecordingPath.split('|');
          this.showVideoRecOptions = true;
          if (this.videoRecordingsArray && this.videoRecordingsArray.length > 0) {
            this.showVideoTab = true;
            this.selectedVideoRec = this.videoRecordingsArray[0];
            const videodata = await lastValueFrom(this.managerService.getRecordingFiles(this.selectedVideoRec));
            // console.log(videodata);
            if (videodata) {
              this.selectedTab = this.showHeader ? this.selectedTab : 'AgentDesktop';
              this.loadVideo(videodata);
              this.isVideoRecordLoaded = true;
            }
          }
        }
      }
    }

    this.renderConsoleAccess();
    if (this.queueList && this.queueList.length === 0) {
      var noQueues = 'You do not have any queues at this time';
    } else this.renderView();
  }

  // isDateValue(dateStr: string): boolean {
  //   const d = new Date(dateStr);
  //   return !isNaN(d.getTime());
  // }
  isDateValue(value: any): boolean {
    if (typeof value !== 'string') return false;
  
    if (!(value.includes('/') || value.includes('-'))) return false;
    
    const d = new Date(value);
    return !isNaN(d.getTime());
  }

  
  useDateOnlyPipe(key: string): boolean {
    if (!key) return false;

    const dateOnlyKeys = [
      'DateOfBirth',
      'Effective Date',
      'Enroll Term Date',
      'Pcpeffdate',
      'Pcptermdate'
      ];
      return dateOnlyKeys.includes(key);
      }


  async checkAuditSurveyExperience() {
    const data: any = await lastValueFrom(this.consoleService.hasAuditSurveyExperience());
    const isValid = ResponseHandler.processResponse(data, 'hasAuditSurveyExperience');
    if (isValid) {
      this.hasAuditSurvey = data.Response.Data;
    }
    // console.log(this.hasAuditSurvey, 'status');
  }
  FollowUpDate(FollowUpDate: any): any {
    throw new Error('Method not implemented.');
  }

  renderConsoleAccess() {
    if (this.isAuditor || this.isManager || this.isStaffer) {
      this.hdrText = (this.isManager || this.isStaffer ? 'Manager' : 'Auditor') + ' Console';

      this.btnText =
        ((this.isManager || this.isStaffer) && this.isAuditor
          ? 'Manage / Audit'
          : this.isManager || this.isStaffer
            ? 'Manage'
            : 'Audit') + ' Agents';
    }
  }
  getHeadingContent(item: any, i: number) {
    return (
      '<h2 class="accordion-header" [id]="\'heading\'' +
      i +
      '"><button class="accordion-button" [ngClass]="{ \'collapsed\': ' +
      i +
      ' != 0 }" type="button" data-bs-toggle="collapse" [attr.data-bs-target]="\'#collapse\'+' +
      i +
      '" [attr.aria-expanded]="' +
      i +
      ' == 0" [attr.aria-controls]="\'collapse\'+' +
      i +
      '"> <span class="menu-item">' +
      item.name +
      ' </span> <span class="count">' +
      item.totalrecords +
      '</span></button></h2>'
    );
  }
  renderView() {
    const currQueueID: any = '';
    let thisList: any = [];
    let finalList: any;
    for (let x = 0; x < this.queueList && this.queueList.length; x++) {
      const q = this.queueList[x];

      if (
        (q.Type == 'Inbound' || q.Type == 'VideoChat' || q.Type == 'TextChat') &&
        q.LinkedQueueCount > 0 &&
        q.HideIfBlended === true
      )
        continue;
      if (this.getFromArray(this.lists, q.Type, 'name') == null) {
        var hdrText;

        hdrText = q.Type.split(/(?=[A-Z])/).join(' ');

        this.lists.push({ name: q.Type, data: [] });

        thisList = this.getFromArray(this.lists, q.Type, 'name');
      } else {
        thisList = this.getFromArray(this.lists, q.Type, 'name');
      }
      let queueItem: any = [];
      let countLabel = null;
      switch (q.Type) {
        case 'Blended':
          var inboundCount = 0;
          for (const i in q.LinkedQueueIDs) {
            const linkedQ = this.getFromArray(this.queueList, q.LinkedQueueIDs[i], 'ID');
            if (linkedQ != null) inboundCount += linkedQ.Items;
          }
          countLabel = inboundCount + '/ ' + q.Items;
          break;
        case 'Inbound':
          countLabel = q.Items;
          break;
        case 'InboundFax':
          countLabel = q.Items;
          break;
        case 'TextChat':
        case 'VideoChat':
          countLabel = q.Items;
          break;
        case 'Outbound':
          countLabel = q.Items;
          break;
        default:
          break;
      }
      queueItem = {
        id: q.ID,
        type: q.Type,
        dialertype: q.DialerType,
        name: q.Name,
        items: q.Items,
        countLabel: countLabel,
        queue: q,
      };

      const index = this.getArrayIndex(this.lists, q.Type, 'name');

      this.lists[index].data.push(queueItem);
      this.lists[index].totalrecords = this.getTotalRecords(this.lists[index]);
    }
  }

  getFromArray(array: any, search: any, propName: any) {
    const index = this.getArrayIndex(array, search, propName);
    if (index != -1) {
      return array[index];
    }
    return null;
  }

  getArrayIndex(array: any, search: any, propName: any) {
    for (let i = 0; i < array.length; i++) {
      if (propName != null) {
        if (array[i][propName] == search) {
          return i;
        }
      } else if (array[i] == search) {
        return i;
      }
    }
    return -1;
  }

  getTotalRecords(item: any) {
    let count = 0;
    for (let i = 0; i < item.data.length; i++) {
      count = count + item.data[i].items;
    }
    return count;
  }

  goToQueue(selectedQueue: any) {
    this.queueService.notifyOtherFromTaskMenu({
      refresh: true,
      menuName: selectedQueue.type,
    });

    this.closeTaskSelectionMenu();
    // console.log('selectedQueue', selectedQueue);
    this.appService.setselectedQueueId(selectedQueue.id);
    localStorage.setItem('qid', selectedQueue.id);
    this.router.navigate([this.clientAbbreviation + '/Queue/' + selectedQueue.type], {
      queryParams: { qid: selectedQueue.id },
    });
  }
  closeTaskSelectionMenu() {
    if (this.selectedSurveyArray && this.selectedSurveyArray.length == 0 && this.checkCommentsLength > 0) {
      const initialState = {
        title: 'Warning: Unsaved Changes Detected',
        contentMsg: 'You have unsaved changes. Would you like to save or discard them?',
        confirmBtnValue: 'Save Changes',
        cancelBtnValue: 'Discard',
        isConfirm: true,
        isDelete: false,
      };

      const config: ModalOptions = {
        backdrop: 'static',
        class: 'confirm-dialog modal-wd-290',
        initialState,
      };

      setTimeout(() => {
        this.closeTaskMenuTimeout = this.modalRef = this.modalService.show(ConfirmDialogComponent, config);
        if (this.modalRef) {
          document.body.classList.add('modal-open');
        }
        this.cd.detectChanges();
      }, 0);

      this.modalRef.content.event.subscribe((result: any) => {
        if (result.value == 'confirm') {
          this.saveSurvey(null, false, null);
          // console.log(this.auditSaved);
        }
        // else {
        //   this.bsModalRef.hide();
        // }
        // this.modalRef.hide();
      });
    } else {
      this.OnHide.emit();
      this.bsModalRef.hide();
    }
    //this.router.navigate([this.clientAbbreviation + '/Console/Interactions']);
    if (this.router.url.includes('/Console/Auditing/Audits')) {
      this.router.navigate([this.clientAbbreviation + '/Console/Auditing/Audits']);
    } else if (this.router.url.includes('/Performance')) {
      this.bsModalRef.hide();
    } else {
      //his.router.navigate([this.clientAbbreviation + '/Console/Interactions']);
    }
  }

  goToConsole() {
    this.closeTaskSelectionMenu();
    this.router.navigate([this.clientAbbreviation + '/Console/Interactions']);
  }

  changeRecording(event) {
    // console.log(event);
    this.isRecordLoaded = false;
    // console.log(this.selectedRecordingValue);
    this.selectedRecordingValue = this.selectedRecordingValue;
    // console.log(this.selectedRecordingValue);
    this.managerService.getRecordingFiles(this.selectedRecordingValue).subscribe(res => {
      // console.log(res);

      if (res) {
        this.loadAudioClick(res);
        this.isRecordLoaded = true;
      }
    });
    // let data = lastValueFrom(this.managerService.getRecordingFiles(this.selectedRecordingValue));
    // console.log(data);
    // if (data) {
    //   this.loadAudioClick(data)
    //   this.isRecordLoaded = true;
    // }
  }
  loadAudioClick(data) {
    const binaryData = 'data:' + data.MimeType + ';base64,' + data.result;
    const binary = Utils.convertDataURIToBinary(binaryData);
    const blob = new Blob([binary], { type: data.MimeType });
    const blobUrl = URL.createObjectURL(blob);
    this.audioSource = blobUrl;
    this.recordingDetails = this.audioSource;
    this.audiofilename = data.fileName;
  }
  changeVideoRecording(event) {
    this.isVideoRecordLoaded = false;
    this.managerService.getRecordingFiles(this.selectedVideoRec).subscribe(res => {
      // console.log(res);

      if (res) {
        this.loadVideo(res);
        this.isVideoRecordLoaded = true;
      }
    });
  }
  loadVideo(data) {
    const binaryData = 'data:' + data.MimeType + ';base64,' + data.result;
    const binary = Utils.convertDataURIToBinary(binaryData);
    const blob = new Blob([binary], { type: data.MimeType });
    const blobUrl = URL.createObjectURL(blob);
    this.videoSource = blobUrl;
    this.videoRecordingfile = this.videoSource;
    this.filename = data.fileName;
  }
  onAuditSurvey() {
    this.isSubmitted = true;
  }

  async getAuditDetailsByInteractionId(interactionID) {
    const res: any = await lastValueFrom(this.auditorService.GetSurveysGroupedByDefinition(interactionID));
    if (res) {
      this.auditData = res.Response.Data;
      // if (res?.Response?.Data?.[0]?.Surveys?.[0]?.Status?.Name === 'Deleted') {
      //   this.isDeletedSurvey = true;
      // } else {
      //   this.isDeletedSurvey = false;
      // }
      // console.log(this.isDeletedSurvey);
      // console.log(this.auditData);
      if (this.auditData && this.auditData.length > 0) {
        this.auditDetails = this.auditData[0];
        // console.log(this.auditDetails);
        // console.log(this.clientAbbreviation);
        this.filteredAuditArray = [];
        if (this.clientAbbreviation == 'BCH') {
          const filteredSurveys =   this.auditData.filter(item => !item.Name.includes('PCH'));
          this.filteredAuditArray = filteredSurveys;
          // this.auditData.forEach(ele => {
          //   // console.log(ele);
          //   if (ele.Name.includes('BCH')) {
          //     //this.filteredAuditArray = [];
          //     this.filteredAuditArray.push(ele);
          //     // console.log(this.filteredAuditArray, 'filteredArray');
          //   }
          // });
        } else {
          this.filteredAuditArray = this.auditData;
        }
        //console.log(this.filteredAuditArray, 'audit array');
        //this.selectedForm = this.filteredAuditArray[0];
        if (this.clientAbbreviation == 'BCH') 
          {
           this.selectedForm = this.filteredAuditArray.length > 1 
          ? this.filteredAuditArray[1] 
         : this.filteredAuditArray[0];
          } 
         else 
         {
          this.selectedForm = this.filteredAuditArray[0];
         }
         if(this.isPerformance){
          this.selectedForm = this.filteredAuditArray.filter(a=>a.Name === this.surveyForm)[0];
        }
        this.selectedTypeArray = this.selectedForm.Types;
        this.selectedType = this.selectedForm.Types[0];
        this.selectedSurveyArray = this.selectedForm.Surveys;
        this.selectedSurvey = this.selectedForm.Surveys[0];
       
       // ------------------ FIXED NO-GRANT LOGIC ------------------
       if (this.noGrantAuditView) 
        {
    
        const loggedUser = this.webStorageService.getItemFromSessionStorage('currentUser');
         const loggedEmail = loggedUser?.Email?.toLowerCase();
        let list = this.buildSubmittedSurveyList();
        list = list.filter(s => {
         const status = s?.Status?.Name?.toLowerCase();
         const reviewerEmail = s?.User?.Email?.toLowerCase();
        if (status === 'submitted') return true;
       if (['complete', 'in progress', 'inprogress'].includes(status)) {
          return reviewerEmail === loggedEmail;
         }
      return false;
      });
      if (list.length === 0) {
      this.selectedSurveyArray = [];
      this.showOpenSurvey = false;
      this.isAudit = false;
      return;
  }
  this.selectedSurveyArray = list;
  this.selectedSurvey = list[0];
  // For UI
  this.showOpenSurvey = true;

  // 5. Calculate allowViewSurvey flag for template
  const selectedStatus = this.selectedSurvey?.Status?.Name?.toLowerCase();
  const selectedReviewer = this.selectedSurvey?.User?.Email?.toLowerCase();

  this.allowViewSurvey =
      selectedStatus === 'submitted' ||
      selectedReviewer === loggedEmail;
    }
// ------------------ END FIXED NO-GRANT LOGIC ------------------
        // if(!this.isAuditor || this.isPerformance){
        //   this.openAuditSurvey();
        // }
        if(this.isPerformance)
          {
          this.openAuditSurvey();
           }
      }
    }
    // console.log(this.filteredAuditArray, 'audit array');
    // console.log(this.selectedType)
    if (this.selectedSurveyArray && this.selectedSurveyArray.length > 0) {
      this.showOpenSurvey = true;
    } else {
      this.showOpenSurvey = false;
    }
  }
  getSelectedType(event) {
    if (event?.currentTarget?.options) {
      this.selectedType = this.selectedForm.Types[event?.currentTarget?.options?.selectedIndex];
    }
  }
  changeFormField(event) {
    // console.log(this.selectedForm, 'selectedform');

    this.selectedTypeArray = this.selectedForm.Types;
    this.selectedType = this.selectedForm.Types[0];
    this.selectedSurveyArray = this.selectedForm.Surveys;
    this.selectedSurvey = this.selectedForm.Surveys[0];
    if (this.selectedSurveyArray && this.selectedSurveyArray.length > 0) {
      this.showOpenSurvey = true;
    } else {
      this.showOpenSurvey = false;
    }
  }
  // checkingSurveyWithDefinitionAndType(selectedForm: any, selectedType: any) {
  //   this.selectedSurveyArray.forEach(item => {
  //     this.auditTypes.push(item.Type.Name);
  //     this.auditDefinations.push(item.SurveyDefinitionID);
  //   });
  //   if (
  //     this.auditTypes.includes(selectedType.Name) &&
  //     this.auditDefinations.includes(selectedForm.SurveyDefinitionID)
  //   ) {
  //     return true;
  //   }
  //   return null;
  // }
  checkingSurveyWithDefinitionAndType(selectedForm: any, selectedType: any): any {
    if (!this.selectedSurveyArray?.length || !selectedForm || !selectedType) {
      return undefined;
    }
    // console.log('Looking for match with:');
    // console.log('selectedType:', selectedType?.Name);
    // console.log('selectedForm ID:', selectedForm?.SurveyDefinitionID);

    this.selectedSurveyArray.forEach(item => {
      console.log('Checking item:', {
        type: item?.Type?.Name,
        defID: item?.SurveyDefinitionID,
        status: item?.Status?.Name,
      });
    });

    return this.selectedSurveyArray.find(
      item =>
        item?.Type?.Name === selectedType?.Name &&
        item?.SurveyDefinitionID === selectedForm?.SurveyDefinitionID 
        //&& item?.Status?.Name !== 'Deleted'
    );
  }

  async createNewAuditSurvey(surveyStatus: boolean) {
    if (surveyStatus && this.selectedType && this.selectedSurvey?.Status?.Name != 'Deleted' && this.selectedSurvey?.SurveyID==null) {
      this.savedSurveyId = undefined;
      this.savedSurveyRes = null;
      this.newSurveyData = null;
      this.surveySections = [];
      this.surveyPermissions = null;
      this.surveyID = null;
      this.showSurveyDetails = false;

      this.surveyTypeID = this.selectedType.ID;
      //this.surveyDefinitionID = this.selectedType.SurveyDefinitionID;
      this.surveyDefinitionID = this.selectedForm.SurveyDefinitionID;

      const surveyDefinitionRes: any = await lastValueFrom(
        this.auditorService.GetSurveyDefinition(this.surveyDefinitionID)
      );

      this.newSurveyData = surveyDefinitionRes.Response.Data;
      this.surveySections = JSON.parse(JSON.stringify(this.newSurveyData.Sections));
      this.showSurveyDetails = true;
    }

    //Filter out deleted surveys before checking for duplicates
    // this.selectedSurveyArray = this.selectedSurveyArray?.filter(survey => survey.Status?.Name !== 'Deleted');

    this.existingSurvey = this.checkingSurveyWithDefinitionAndType(this.selectedForm, this.selectedType);
    console.log('existingSurvey', this.existingSurvey);
    if (
      surveyStatus == true &&
      this.selectedSurveyArray &&
      this.selectedSurveyArray.length > 0 &&
      //this.selectedSurvey?.Status?.Name == 'Deleted' &&
      this.existingSurvey
    ) {
      const initialState = {
        title: 'Duplicate Survey',
        contentMsg:
          'You already have a survey that uses this form. \n \n' +
          this.selectedSurvey.SurveyID +
          ':' +
          this.selectedForm.Name +
          '-' +
          this.selectedType?.Name +
          '(' +
          this.selectedSurvey.Status.Name +
          ')' +
          '\n \n' +
          '\n \n Would you like to open it?',
        confirmBtnValue: 'Ok',
        cancelBtnValue: 'Cancel',
        isConfirm: true,
        isDelete: false,
      };

      const config: ModalOptions = {
        backdrop: 'static',
        class: 'confirm-dialog modal-wd-290',
        initialState,
      };

      this.newAuditSurveyTimeout = setTimeout(() => {
        this.modalRef = this.modalService.show(ConfirmDialogComponent, config);
        this.modalRef.content.event.subscribe((result: any) => {
        if (result?.value === 'confirm') {
          this.selectedSurvey = this.existingSurvey;
          this.openAuditSurvey();
        }
        this.modalRef.hide();
        this.cd.detectChanges();
      });
        if (this.modalRef) {
          document.body.classList.add('modal-open');
        }
        this.cd.detectChanges();
      }, 0);

      // this.modalRef.content.event.subscribe((result: any) => {
      //   if (result.value == 'confirm') {
      //     this.selectedSurvey = this.existingSurvey;
      //     this.openAuditSurvey();
      //   }
      //   this.modalRef.hide();
      // });
    } else {
      this.showSurveyDetails = true;

      let user = this.webStorageService.getItemFromSessionStorage('currentUser');
      this.newName = 'New';
      this.userDetails = user;

      console.log(this.savedSurveyId, 'savedSurvey');
      // console.log(this.openAuditResponse, 'vall');
      if (this.savedSurveyId != undefined && !this.duplicateSavedSurveyId) {
        this.newName = '';

        const surveyRes: any = await lastValueFrom(this.auditorService.GetSurvey(this.savedSurveyId,null));
        this.savedSurveyRes = surveyRes.Response.Data;
        this.userDetails = this.savedSurveyRes.User;
        if (user?.UserID == this.userDetails?.UserID) {
          this.isSameAgent = Number(user.UserID) === Number(this.userDetails?.UserID);
        }
        if (this.isSameAgent) {
          this.showSaveBtn = true;
          this.saveLabel = 'Save Changes';
        } else {
          this.showSaveBtn = false;
          this.saveLabel = ''; 
        }
        const surveyPermissionsRes: any = await lastValueFrom(
          this.auditorService.GetSurveyPermissions(this.savedSurveyId)
        );
        this.surveyPermissions = surveyPermissionsRes.Response.Data;
        if (this.openAuditResponse == true) {
          const surveyDefinitionRes: any = await lastValueFrom(
            this.auditorService.GetSurveyDefinition(this.selectedForm.SurveyDefinitionID)
          );
          this.newSurveyData = surveyDefinitionRes.Response.Data;
          this.surveySections = surveyDefinitionRes.Response.Data.Sections;
          this.openAuditResponse = false;
        }
      } else {
        const surveyDefinitionRes: any = await lastValueFrom(
          this.auditorService.GetSurveyDefinition(this.selectedForm.SurveyDefinitionID)
        );
        this.newSurveyData = surveyDefinitionRes.Response.Data;
        this.surveySections = surveyDefinitionRes.Response.Data.Sections;

        const surveyPermissionsRes: any = await lastValueFrom(this.auditorService.GetSurveyPermissions(null));
        this.surveyPermissions = surveyPermissionsRes.Response.Data;
      }

      // console.log(this.surveyPermissions);

      // console.log(this.savedSurveyRes, 'getsurvey');
      //  console.log(surveyRes);

      // if(this.surveyPermissions.SurveyID != null){
      this.surveyID = this.surveyPermissions.SurveyID;
      if (this.surveyID == 0) {
        this.surveyActionID = this.surveyPermissions.Actions[0]?.SurveyActionID;
        this.surveyID = null;
      }
      // } 
      this.surveyTypeID = this.selectedType?.ID;
      this.surveyDefinitionID = this.selectedForm.SurveyDefinitionID;

      this.isSubmitted = true;
      let sectionTotal = 0;
      let totalSectionPoints = 0;
      this.surveySections.forEach(ele => {
        ele.Points = 0;
        ele.Max = 0;
        ele.FieldGroup.Changes = {};
        ele.FieldGroup.Data = {};
        ele.surveyID = null;
        ele.commentID = 0;
        // console.log(`Section: ${ele.Name}, Max: ${ele.Max}, Points: ${ele.Points}`);

        // ele.FieldGroup.Comments = [];
        ele.FieldGroup.Fields.forEach(element => {
          if (this.savedSurveyRes) {
            this.savedSurveyRes.Sections.forEach(savedElement => {
              savedElement.Responses.forEach(savedResponse => {
                if (savedResponse.Values[0] == null || savedResponse.Values[0] == 'SelectOne') {
                  const nullObject = {
                    FieldOptionID: null,
                    Name: 'SelectOne',
                    Value: '-1',
                    DisplayOrder: null,
                    ScoreValue: 0,
                  };
                  // element.FieldOptions.unshift(nullObject)
                  const filteredSelectOption = element.FieldOptions.filter(i => i.Name == 'SelectOne');
                  if (filteredSelectOption && filteredSelectOption.length <= 0) {
                    element.FieldOptions.unshift(nullObject);
                  }
                }
                if (savedResponse.Label?.trim() == element.Name?.trim()) {
                  if (savedResponse.Values[0] == null) {
                    savedResponse.Values[0] = 'SelectOne';
                  }
                  const FieldOptions = element.FieldOptions.filter(i => i.Name == savedResponse.Values[0]);
                  if (FieldOptions.length > 0) 
                    {
                  element.selectedFieldOption = FieldOptions[0];
                   }
                  // console.log(savedResponse);
                  if (savedResponse.Comments.length > 0) {
                    //let lastCommentIndex = savedResponse.Comments.length - 1;
                    let comments = savedResponse.Comments.filter(x=>x.Comment !="");
                    if(comments.length>0){
                      element.Comments = savedResponse.Comments[comments.length - 1].Comment;
                      element.FieldResponseCommentID = savedResponse.Comments[comments.length - 1].FieldResponseCommentID;
                      element.commentValue = 1
                    }
                    else{
                      element.commentValue = 0
                    }
                  } else {
                    element.commentValue = 0;
                  }

                  // element.Comments = 'test 1' Response.Data.Sections[0].Responses[0].Comments[0].Comment
                  // console.log(element.Comments);

                  this.showPoints = true;
                  if (FieldOptions.length > 0) {
                  ele.Points += FieldOptions[0].ScoreValue;
                  }
                  if (element.DefaultOption != null) {
                    ele.Max += element.FieldOptions.reduce((prev, current) =>
                    prev.ScoreValue > current.ScoreValue ? prev : current
                    ).ScoreValue;
                    }
                  // ele.Max += element.FieldOptions.reduce((prev, current) =>
                  //   prev.ScoreValue > current.ScoreValue ? prev : current
                  // ).ScoreValue;
                  // ele.groupLabelStatus = 'Complete'
                  ele.zeroPoints = true;
                }
              });
            });
          } else {
            if (element.DefaultOption != null) {
              const FieldOptions = element.FieldOptions.filter(
                i => i.FieldOptionID == element.DefaultOption.FieldOptionID
              );
              element.selectedFieldOption = FieldOptions[0];
              this.showPoints = true;
              ele.Points += FieldOptions[0].ScoreValue;
              element.commentValue = 0;
              ele.Max += element.FieldOptions.reduce((prev, current) =>
                prev.ScoreValue > current.ScoreValue ? prev : current
              ).ScoreValue;

              // console.log(element.selectedFieldOption, 'by default');

              // ele.groupLabelStatus = 'Complete'
              ele.zeroPoints = true;
            } else if (element.DefaultOption == null) {
              this.showPoints = false;

              const nullObject = {
                FieldOptionID: null,
                Name: 'SelectOne',
                Value: '-1',
                DisplayOrder: null,
                ScoreValue: 0,
              };
              // element.FieldOptions.unshift(nullObject)
              const filteredSelectOption = element.FieldOptions.filter(i => i.Name == 'SelectOne');
              if (filteredSelectOption && filteredSelectOption.length <= 0) {
                element.FieldOptions.unshift(nullObject);
              }
              element.FieldOptions[0].ScoreValue = 0;
              element.commentValue = 0;
              element.selectedFieldOption = element.FieldOptions[0];
              if (this.savedSurveyRes) {
                this.savedSurveyRes.Sections.forEach(savedElement => {
                  savedElement.Responses.forEach(savedResponse => {
                    if (savedResponse.Label?.trim() == element.Name?.trim()) {
                      if (savedResponse.Values[0] == null) {
                        savedResponse.Values[0] = 'SelectOne';
                      }
                      const FieldOptions = element.FieldOptions.filter(i => i.Name == savedResponse.Values[0]);
                      if (FieldOptions.length > 0) 
                        {
                      element.selectedFieldOption = FieldOptions[0];
                      }
                      this.showPoints = true;
                      // ele.Points += FieldOptions[0].ScoreValue;
                      // ele.Max +=  FieldOptions.reduce((prev, current) => (prev.ScoreValue > current.ScoreValue) ? prev : current).ScoreValue;
                      // ele.groupLabelStatus = 'Complete'
                      // ele.zeroPoints = true
                    }
                  });
                });
              }

              if (element.FieldRestrictions?.some(x => x.Name === 'Required') && (!element.selectedFieldOption || element.selectedFieldOption.Name == 'SelectOne')) {
                ele.groupLabelStatus = 'In Progress';
              } 
              else {
                ele.groupLabelStatus = 'Complete';
              }
            }
          }
          if (!element.showComments) {
            element.showComments = false;
          }
          if (element.FieldRestrictions?.some(x => x.Name === 'Required') && ( !element.selectedFieldOption || element.selectedFieldOption.Name == 'SelectOne') ){
            ele.groupLabelStatus = 'In Progress';
          } 
          else {
            ele.groupLabelStatus = 'Complete';
          }
          if (element.selectedFieldOption) 
            {
            const name = element.ShortName;
            const value = element.selectedFieldOption.Value;
            ele.FieldGroup.Data[name] = value;
            }
          //const name = element.ShortName;
          //const value = element.selectedFieldOption.Value;
          // console.log(name, value, 'datavalue');
          //ele.FieldGroup.Data[name] = value;

          //set for API
          // element.Changes={}
          // console.log(element);
        });
        if (ele.Points == 0 && ele.Max == 0) {
          ele.showPoints = false;
        } else {
          ele.showPoints = true;
        }
        this.checkStatusArray.push(ele.groupLabelStatus);
        ele.Score = this.getPercentage(ele.Points, ele.Max);
        ele.Score = isNaN(ele.Score) ? 0 : ele.Score;
        sectionTotal += ele.Points;
        const isBonusByName = ele.Name?.toLowerCase() === 'bonus' || ele.FieldGroup?.Name?.toLowerCase() === 'bonus';
        const scorePercentage = ele.ScorePercentage ?? 100;
        const isExcludedByWeight = scorePercentage === 0 || isBonusByName;
        if (!isExcludedByWeight) {
          totalSectionPoints += ele.Max;
        }
      });
      sectionTotal = this.setDefaultValue(sectionTotal);
      this.surveySections.sectionTotal = sectionTotal;
      this.surveySections.totalSectionPoints = totalSectionPoints;
      this.surveySections.totalSectionScore = this.getPercentage(
        this.surveySections.sectionTotal,
        this.surveySections.totalSectionPoints
      );
      //call submitsurvey API

      this.saveSectionData = this.surveySections.map(savedSurveyDetails => {
        const {
          Points,
          Max,
          Score,
          FieldGroup: { Data, Changes, FieldGroupID },
        } = savedSurveyDetails;

        return { Points, Max, Score, Data, Changes, FieldGroupID };
      });

      if (this.surveyID == null) {
        this.saveSurvey(null, false, null);
        this.status = true;
      }
      //  console.log(this.surveyPermissions, 'perm');
      if (this.checkStatusArray.includes('In Progress')) {
        // if (this.surveyPermissions.Status.Name == 'Pending'){
        //   this.surveySections.sectionLabelStatus = 'In Progress';
        // } 
        this.surveySections.sectionLabelStatus = 'In Progress';
        this.showSubmitBtn = false;
      } else {
        // this.showSubmitBtn = true;
        this.surveyPermissions.Actions.forEach(element => {
          if (element.Name == 'Submit') {
            this.submitLabel = element.Label;
            //this.surveyActionID = element.SurveyActionID;
            this.showSubmitBtn = true;
          }
        });
        //this.surveySections.sectionLabelStatus = this.surveyPermissions.Status.Name;
        const allComplete = Object.values(this.checkStatusArray).every( status => status === "Complete" );
        this.surveySections.sectionLabelStatus = allComplete == true ? "Complete" : "In Progress";
        if (this.surveyPermissions.Status.Name == 'Submitted') {
          this.showSubmitBtn = false;
          this.surveySections.sectionLabelStatus = 'Submitted';
        }
      }
      // console.log(this.surveySections,'check sections');

      // if (this.surveySections.sectionLabelStatus == 'Complete') {

      // }
      if(!this.isPerformance){
        this.showSaveBtn = false;
        this.showDeleteBtn = false;
        this.showExportBtn = false;

        this.saveLabel = '';
        this.deleteLabel = '';
        this.exportLabel = '';
        this.surveyPermissions.Actions.forEach(element => {
          if (element.Name == 'SaveDraft') {
            this.saveLabel = element.Label;
            //this.surveyActionID = element.SurveyActionID;
            this.showSaveBtn = true;
            // this.showSubmitBtn = false
          }
          if (element.Name == 'Delete') {
            this.deleteLabel = element.Label;
            //this.surveyActionID = element.SurveyActionID;
            this.showDeleteBtn = true;
          }
          if (element.Name == 'Export') {
            this.exportLabel = element.Label;
            //this.surveyActionID = element.SurveyActionID;
            this.showExportBtn = true;
          }
      });
    }else{
          this.exportLabel = 'Export Excel';        
          this.showExportBtn = true;
    }

      // if(this.surveyPermissions.Status.Name == '')
    }
  }

  changeFieldOption(event, fieldObject, i, selectedFormFieldOption) {
    this.updateScoreValue(selectedFormFieldOption);
    // console.log(fieldObject, 'fieldobject');
  }

  updateScoreValue(selectedFormFieldOption) {
    let sectionTotal = 0;
    this.checkStatusArray = [];
    this.surveySections.forEach(ele => {
      ele.Points = 0;

      ele.FieldGroup.Fields.forEach(element => {
        // console.log(element.selectedFieldOption);

        if (element.selectedFieldOption.Name == 'SelectOne') {
          ele.groupLabelStatus = 'In Progress';
        } else {
          ele.groupLabelStatus = 'Complete';
        }
        ele.Points += element.selectedFieldOption.ScoreValue;
        // console.log(element.selectedFieldOption,'updated field options');

        ele.Score = this.getPercentage(ele.Points, ele.Max);
        // console.log(ele.Score, 'per');
        // if(ele.Score == NaN){
        //   console.log("HI");
        //   ele.Score = 0

        // }
        ele.Score = isNaN(ele.Score) ? 0 : ele.Score;
        // console.log(ele.Score, 'perup');

        // this.updatedSectionsArray.push(element.selectedFieldOption);
        // console.log(this.updatedSectionsArray,'updated sections list');
        // if(!ele.Changes){
        // }
        if (element.selectedFieldOption) {
          // console.log(ele);
          const name = element.ShortName;
          const value = element.selectedFieldOption.Name == 'SelectOne'? parseInt(element.selectedFieldOption.Value): element.selectedFieldOption.Name;

          // ele.Changes={name,value};
          //  console.log(element, 'element');
          // console.log(element.DefaultOption,'default')
          // if (element.DefaultOption) {
          //   if (element.DefaultOption.FieldOptionID != element.selectedFieldOption.FieldOptionID) {
          //     ele.FieldGroup.Changes[name] = value;
          //     // const { Changes,Points,sectionTotal,percentage} = ele
          //     // const extractedFields = {Changes,Points,sectionTotal,percentage}
          //     // console.log(extractedFields,'extracted');
          //   }
          // } else if (element.selectedFieldOption.Name != 'SelectOne') {
          //   ele.FieldGroup.Changes[name] = value;
          // }

          if (element.selectedFieldOption) {
            if (ele.FieldGroup.Changes.hasOwnProperty(name)) {
              if (ele.FieldGroup.Changes[name] != value) {
                ele.FieldGroup.Changes[name] = value;
              }
            } else if (element.selectedFieldOption.Name != 'SelectOne' && selectedFormFieldOption?.FieldOptionID == element.selectedFieldOption.FieldOptionID) {
              ele.FieldGroup.Changes[name] = value;
            }
          }

          // console.log(element.selectedFieldOption,'selectedfieldoption')
          // console.log(element.Name,'seleceted Name');
        }
      });
      const hasIncompleteRequiredField = ele.FieldGroup.Fields.some(
        element =>
          element.FieldRestrictions?.some(x => x.Name === 'Required') &&
          (!element.selectedFieldOption ||
            element.selectedFieldOption.Name === 'SelectOne')
      );
      
      ele.groupLabelStatus = hasIncompleteRequiredField
        ? 'In Progress'
        : 'Complete';


      sectionTotal += ele.Points;
      this.checkStatusArray.push(ele.groupLabelStatus);
    });

    sectionTotal = this.setDefaultValue(sectionTotal);
    this.surveySections.sectionTotal = sectionTotal;
    this.surveySections.totalSectionScore = this.getPercentage(
      this.surveySections.sectionTotal,
      this.surveySections.totalSectionPoints
    );
    // console.log(this.surveySections, 'final data');
    // console.log(this.surveySections.totalSectionScore, 'per');

    this.saveSectionData = this.surveySections.map(savedSurveyDetails => {
      const {
        Points,
        Max,
        Score,
        FieldGroup: { Changes, FieldGroupID },
      } = savedSurveyDetails;

      return { Points, Max, Score, Changes, FieldGroupID };
    });

    // console.log(this.saveSectionData, 'savedSection');
    if (this.checkStatusArray.includes('In Progress')) {
      this.surveySections.sectionLabelStatus = 'In Progress';
        this.showSubmitBtn = false;
      // if (this.surveyPermissions.Status.Name == 'Pending') {
      //   this.surveySections.sectionLabelStatus = 'In Progress';
      //   this.showSubmitBtn = false;
      // }
    } else {
      //  this.surveySections.sectionLabelStatus = this.surveyPermissions.Status.Name;
      this.surveyPermissions.Actions.forEach(element => {
        if (element.Name == 'Submit') {
          this.submitLabel = element.Label;
          //this.surveyActionID = element.SurveyActionID;
          this.showSubmitBtn = true;
        }
        const allComplete = Object.values(this.checkStatusArray).every( status => status === "Complete" );
        this.surveySections.sectionLabelStatus = allComplete == true ? "Complete" : "In Progress";
        //this.surveySections.sectionLabelStatus = this.surveyPermissions.Status.Name;
        if (this.surveySections.sectionLabelStatus == 'Submitted') {
          this.showSubmitBtn = false;
        }
      });
    }
  }
  private setDefaultValue(sectionTotal: number = 0): number {
    if (this.clientAbbreviation == 'AHP') {
      let isExists = this.surveySections?.filter(section => section.Name.toLowerCase() === 'compliance');
      if (isExists?.length > 0) {
        const isTrue = isExists[0].FieldGroup?.Fields?.some(field => ['yes', 'n/a'].includes(field.selectedFieldOption?.Value?.toLowerCase())) ?? false;

        if (!isTrue) {
          sectionTotal = 60;
          this.IsCompliance = true;
        }else{
          this.IsCompliance = false;
        }
      }
    }
    return sectionTotal;
  }

  getPercentage(partialValue, totalValue) {
    // let percentage = (100 * partialValue) / totalValue;
    //   if(percentage.includes('.')){

    //   }
    return (100 * partialValue) / totalValue;
  }

  async showCommentBox(index1, index2) {
    // const showCommentState = this.surveySections[index1].FieldGroup.Fields[index2].showComments;
    // this.surveySections[index1].FieldGroup.Fields[index2].showComments = showCommentState ? false : true;

    const fieldGroup = this.surveySections[index1].FieldGroup;
    const field = fieldGroup.Fields[index2];

    const showCommentState = field.showComments;
    field.showComments = !showCommentState;

    if (field.showComments) {

      const response = this.savedSurveyRes?.Sections
        ?.find(s => s.FieldGroupID === fieldGroup.FieldGroupID)
        ?.Responses
        ?.find(r => r.FieldName === field.ShortName);

      field.Comments = response?.Comments
        ?.map(c => c.Comment)
        ?.filter(c => c?.trim())
        ?.join('\n') || '';
    }
    // console.log(this.surveySections, 'comm');
  }
  // async onFocusOutEvent(event: any, index1, index2) {
  //   const inputElement = event.target.value;
  //   this.surveySections[index1].FieldGroup.Fields[index2].Comments = inputElement;
  //   const content = this.surveySections[index1].FieldGroup.Fields[index2].Comments;
  //   const fieldGroupID = this.surveySections[index1].FieldGroup.FieldGroupID;
  //   const fieldName = this.surveySections[index1].FieldGroup.Fields[index2].ShortName;

  //   const commentID = this.surveySections[index1].FieldGroup.Fields[index2].FieldResponseCommentID
  //     ? this.surveySections[index1].FieldGroup.Fields[index2].FieldResponseCommentID
  //     : null;
  //   //console.log(commentID);
  //   this.checkCommentsLength = content.length;
  //   if (content.length > 0) {
  //     this.surveySections[index1].FieldGroup.Fields[index2].commentValue = 1;
  //   } else {
  //     this.surveySections[index1].FieldGroup.Fields[index2].commentValue = 0;
  //   }
  //   const data = {
  //     surveyID: this.savedSurveyId,
  //     commentID: commentID,
  //     fieldGroupID: fieldGroupID,
  //     fieldName: fieldName,
  //     content: content,
  //   };
  //   const surveyCommentSaveRes: any = await lastValueFrom(this.auditorService.EditSurveyComments(data));
  //   // console.log(surveyCommentSaveRes.Response.Data, 'comment');
  //   this.checkCommentsLength = 0;
  // }
  async onFocusOutEvent(event: any, index1: number, index2: number) {
    const newInput = event.target.value.trim();
    const fieldGroup = this.surveySections[index1].FieldGroup;
    const field = fieldGroup.Fields[index2];
  
    const comments = this.savedSurveyRes?.Sections
      .find(s => s.FieldGroupID === fieldGroup.FieldGroupID)
      ?.Responses.find(r => r.FieldName === field.ShortName)
      ?.Comments?.[0] || null;
  
    const commentID = comments?.FieldResponseCommentID ?? null;
  
    let updatedComment = field.Comments || "";
    if (newInput && updatedComment !== newInput && !updatedComment.includes(newInput)) {
      updatedComment = updatedComment ? `${updatedComment} ${newInput}` : newInput;
    }
  
    field.Comments = updatedComment.trim();
    field.commentValue = updatedComment.trim().length > 0 ? 1 : 0;
    this.checkCommentsLength = updatedComment.trim().length;
  
    const data = {
      surveyID: this.savedSurveyId,
      commentID: commentID,
      fieldGroupID: fieldGroup.FieldGroupID,
      fieldName: field.ShortName,
      content: updatedComment,
    };
  
    await lastValueFrom(this.auditorService.EditSurveyComments(data));
    const surveyRes: any = await lastValueFrom(this.auditorService.GetSurvey(this.savedSurveyId,null));
    this.savedSurveyRes = surveyRes.Response.Data;
  
    this.checkCommentsLength = 0;
  }

  async saveSurvey(event, delOpt: boolean, action: any) {
    // console.log(delOpt, 'del');

    // console.log(event);
    // console.log(this.surveyPermissions);
    if (action != null) {
      this.surveyPermissions.Actions.forEach(element => {
        if (element.Label == action) {
          this.surveyActionID = element.SurveyActionID;
        }
      });
    }
    if (this.savedSurveyId && !this.duplicateSavedSurveyId) {
      this.surveyID = this.savedSurveyId;
    } else {
      this.surveyID = null;
    }
    const data = {
      surveyID: this.surveyID,
      surveyActionID: this.surveyActionID,
      surveyTypeID: this.surveyTypeID,
      surveyDefinitionID: this.surveyDefinitionID,
      interactionID: this.interactionId,
      isCompliance: this.IsCompliance,
      survey: {
        Sections: this.saveSectionData,
        Total: Number(this.surveySections.totalSectionScore),
        TotalPoints: this.surveySections.sectionTotal,
        TotalMax: this.surveySections.totalSectionPoints,
      },

      overwrite: false,
      scorecheck: false,
    };

    if (delOpt == true) {
      const initialState = {
        title: 'Deleting Audit',
        contentMsg: 'Are you sure you want to delete this audit?',
        cancelBtnValue: 'Cancel',
        deleteBtnValue: 'Delete',
        isConfirm: false,
        isDelete: true,
      };

      const config: ModalOptions = {
        backdrop: 'static',
        class: 'confirm-dialog modal-wd-290',
        initialState,
      };

      this.saveSurveyTimeout = setTimeout(() => {
        this.modalRef = this.modalService.show(ConfirmDialogComponent, config);
        this.modalRef.content.event.subscribe(async (result: any) => {
          if (result.value == 'delete') {
            const surveySaveRes: any = await lastValueFrom(this.auditorService.saveSubmitSurvey(data));
  
            const surveyDefinitionsRes: any = await lastValueFrom(
              this.auditorService.GetSurveyDefinitions(data.interactionID)
            );
            let surveyDefinitions = surveyDefinitionsRes.Response.Data.filter(item=>item.SurveyDefinitionID == data.surveyDefinitionID);
            //this.emptySurveys = surveyDefinitionsRes.Response.Data.Surveys;
            this.emptySurveys = surveyDefinitions[0].Surveys;
            this.selectedTypeArray = surveyDefinitions[0].Types;
            console.log('Raw surveys from API:', this.emptySurveys);
            this.selectedSurveyArray = this.emptySurveys;
            this.selectedSurvey = this.selectedSurveyArray[0];
            //this.selectedSurveyArray = this.emptySurveys.filter(survey => survey.Status?.Name !== 'Deleted');
            if (this.selectedSurveyArray && this.selectedSurveyArray.length <= 0) {
              this.showOpenSurvey = false;
            }
            this.emptySections = surveyDefinitionsRes.Response.Data[0].Sections;
            if (this.emptySections && this.emptySections.length <= 0) {
              this.surveySections = [];
              this.isSubmitted = false;
            }
  
            console.log(surveySaveRes, 'saved after del');
            if (surveySaveRes.Response.Data != null) {
              this.savedSurveyId = surveySaveRes.Response.Data;
              //this.savedSurveyId = null;
            }
            if (typeof surveySaveRes.Response.Data === 'object') {
              this.savedSurveyId = surveySaveRes.Response.Data.ID;
              //this.savedSurveyId = null;
            }
  
            this.savedSurveyRes = null;
            this.surveyID = null;
  
            //this.isDeleted = true;
            // console.log(this.savedSurveyRes, 'del');
          }
          this.modalRef.hide();
        });
        if (this.modalRef) {
          document.body.classList.add('modal-open');
        }
        this.cd.detectChanges();
      }, 0);

      // this.modalRef.content.event.subscribe(async (result: any) => {
      //   if (result.value == 'delete') {
      //     const surveySaveRes: any = await lastValueFrom(this.auditorService.saveSubmitSurvey(data));

      //     const surveyDefinitionsRes: any = await lastValueFrom(
      //       this.auditorService.GetSurveyDefinitions(this.interactionId)
      //     );

      //     this.emptySurveys = surveyDefinitionsRes.Response.Data[0].Surveys;
      //     console.log('Raw surveys from API:', this.emptySurveys);
      //     this.selectedSurveyArray = this.emptySurveys;
      //     //this.selectedSurveyArray = this.emptySurveys.filter(survey => survey.Status?.Name !== 'Deleted');
      //     if (this.selectedSurveyArray && this.selectedSurveyArray.length <= 0) {
      //       this.showOpenSurvey = false;
      //     }
      //     this.emptySections = surveyDefinitionsRes.Response.Data[0].Sections;
      //     if (this.emptySections && this.emptySections.length <= 0) {
      //       this.surveySections = [];
      //       this.isSubmitted = false;
      //     }

      //     console.log(surveySaveRes, 'saved after del');
      //     if (surveySaveRes.Response.Data != null) {
      //       this.savedSurveyId = surveySaveRes.Response.Data;
      //       this.savedSurveyId = null;
      //     }
      //     if (typeof surveySaveRes.Response.Data === 'object') {
      //       this.savedSurveyId = surveySaveRes.Response.Data.ID;
      //       this.savedSurveyId = null;
      //     }

      //     this.savedSurveyRes = null;
      //     this.surveyID = null;

      //     this.isDeleted = true;
      //     // console.log(this.savedSurveyRes, 'del');
      //   }
      //   this.modalRef.hide();
      // });
    } else {
      // if (this.isDeleted == true) {
      //   data.overwrite = true;
      // }
      const surveySaveRes: any = await lastValueFrom(this.auditorService.saveSubmitSurvey(data));
      // console.log(surveySaveRes);
      const dataFromAPI = surveySaveRes?.Response?.Data;

      if (typeof dataFromAPI === 'object' && dataFromAPI?.ID) {
        this.savedSurveyId = dataFromAPI;
        this.surveyID = dataFromAPI.ID;
      } else if (typeof dataFromAPI === 'number') {
        this.savedSurveyId = dataFromAPI;
        this.surveyID = dataFromAPI;
      } else {
        this.savedSurveyId = null;
        this.surveyID = null;
        //console.warn('No valid survey ID returned from backend');
      }
      if (surveySaveRes.Response.Data != null) {
        this.savedSurveyId = surveySaveRes.Response.Data;
        //this.duplicateSurveyId = surveySaveRes.Response.Data;
      }
      if (typeof surveySaveRes.Response.Data === 'object' && surveySaveRes.Response.Data.ID != null) {
        this.savedSurveyId = surveySaveRes.Response.Data.ID;
        this.duplicateSavedSurveyId = surveySaveRes.Response.Data.Deleted;
      }

      // let surveyRes: any = await lastValueFrom(this.auditorService.GetSurvey(this.savedSurveyId));
      // if (action === 'Save Changes' || action === 'Submit Audit') {
      //   console.log('Triggering auditChanged for interaction:', data.interactionID);
      // this.appService.notifyAuditChange(data.interactionID);
      // }

      if (event) {
        await this.createNewAuditSurvey(false);
        this.auditSaved = true;
        await this.getAuditDetailsByInteractionId(this.interactionId);
        //if (this.selectedSurvey) {
        // this.surveySections.sectionLabelStatus = this.selectedSurvey.Status.Name;
        //}
        // this.surveySections.sectionLabelStatus = this.selectedSurvey.Status.Name;
      }

      // Reset checkCommentsLength after successful save to prevent false "unsaved changes" warning
      this.checkCommentsLength = 0;

      console.log(this.surveyPermissions, 'permision status');

      // console.log(this.status);
    }
  }

  // async openAuditSurvey() {
  //   console.log(this.surveyID);
  //   this.newName = '';
  //   this.showSurveyDetails = true;

  //   this.openAuditResponse = true;
  //   this.savedSurveyId = this.selectedSurvey.SurveyID;
  //   this.isChecked = false;

  //   await this.createNewAuditSurvey(false);
  //   let user = this.webStorageService.getItemFromSessionStorage('currentUser');
  //   this.userEmail = user.Email;
  //   this.surveyUserEmail = this.savedSurveyRes.User.Email;
  //   console.log(this.userEmail == this.surveyUserEmail);

  //   this.surveySections.sectionLabelStatus = this.selectedSurvey.Status.Name;
  // }
  // async openAuditSurvey() {
  //   if (this.selectedSurvey && this.selectedSurvey.SurveyID) {
  //     this.savedSurveyId = this.selectedSurvey.SurveyID;
  //     this.openAuditResponse = true;
  //     await this.createNewAuditSurvey(false);
  //   } else if (this.selectedType && this.selectedSurveyArray?.length) {
  //     const matchingSurveys = this.selectedSurveyArray.filter(survey => survey.Type?.Name === this.selectedType.Name);

  //     if (matchingSurveys.length > 0) {
  //       const firstMatch = matchingSurveys[0];
  //       this.savedSurveyId = firstMatch.SurveyID;
  //       this.openAuditResponse = true;
  //       await this.createNewAuditSurvey(false);
  //     } else {
  //       this.savedSurveyId = undefined;
  //       this.openAuditResponse = false;
  //       await this.createNewAuditSurvey(true);
  //     }
  //   } else {
  //     //alert('Please select a survey or a type to open.');
  //     return;
  //   }
  //   console.log(this.surveyID);
  //   this.newName = '';
  //   this.showSurveyDetails = true;

  //   this.openAuditResponse = true;
  //   this.savedSurveyId = this.selectedSurvey.SurveyID;
  //   this.isChecked = false;

  //   await this.createNewAuditSurvey(false);
  //   let user = this.webStorageService.getItemFromSessionStorage('currentUser');
  //   this.userEmail = user.Email;
  //   this.surveyUserEmail = this.savedSurveyRes.User.Email;
  //   console.log(this.userEmail == this.surveyUserEmail);

  //   if (this.selectedSurvey?.Status?.Name) {
  //     this.surveySections.sectionLabelStatus = this.selectedSurvey.Status.Name;
  //   }
  //   if (this.selectedSurvey && this.selectedSurvey.SurveyID) {
  //     this.savedSurveyId = this.selectedSurvey.SurveyID;
  //     this.openAuditResponse = true;
  //     if (this.selectedSurvey.Type) {
  //       this.selectedType = this.selectedSurvey.Type;
  //     }

  //     await this.createNewAuditSurvey(false);
  //   }
  //   //this.surveySections.sectionLabelStatus = this.selectedSurvey.Status.Name;
  // }
  async openAuditSurvey() {
    if (this.selectedSurvey && this.selectedSurvey.Status?.Name === 'Deleted' && this.selectedSurvey.SurveyID==null) {
      this.savedSurveyId = undefined;
      this.openAuditResponse = false;
      await this.createNewAuditSurvey(true);
      return;
    }
    if (!this.selectedSurvey || !this.selectedSurvey.SurveyID) {
      return;
    }

    this.savedSurveyId = this.selectedSurvey.SurveyID;
    this.openAuditResponse = true;
    this.newName = '';
    this.showSurveyDetails = true;
    this.isChecked = false;

    // align form & types to the survey's definition (needed in no-grant aggregated list)
    if (this.noGrantAuditView) 
      {
const selDefId = this.selectedSurvey?.SurveyDefinitionID;
const defList = (this.filteredAuditArray?.length ? this.filteredAuditArray : this.auditData) || [];
const matchedDef = defList.find((d: any) => d?.SurveyDefinitionID === selDefId);
if (matchedDef) {
  this.selectedForm = matchedDef;
  this.selectedTypeArray = matchedDef.Types || [];
}
// align selectedType by ID/Id
const selTypeId = this.selectedSurvey?.Type?.ID ?? this.selectedSurvey?.Type?.Id;
if (selTypeId && Array.isArray(this.selectedTypeArray)) {
  this.selectedType =
    this.selectedTypeArray.find((t: any) => (t.ID ?? t.Id) === selTypeId) || this.selectedTypeArray[0];
}
      }
    await this.createNewAuditSurvey(false);

    const user = this.webStorageService.getItemFromSessionStorage('currentUser');
    this.userEmail = user?.Email?.toLowerCase();
    this.surveyUserEmail = this.savedSurveyRes?.User?.Email?.toLowerCase();

    // console.log('User match:', this.userEmail === this.surveyUserEmail);

    if (this.selectedSurvey?.Status?.Name) {
      this.surveySections.sectionLabelStatus = this.selectedSurvey.Status.Name;
    }

    if (this.selectedSurvey?.Type) {
      this.selectedType = this.selectedTypeArray
      .find(x => x.Id === this.selectedSurvey.Type.Id);
    }
  }

  async getExportExcel() {
    const surveyId = this.selectedSurvey.SurveyID;
    const isAHPCompliance = this.setDefaultValue();
    const complianceData = {
      isCompliance: this.IsCompliance.toString(),
      defaultValue: isAHPCompliance.toString()
    };
    const excelRes: any = await lastValueFrom(this.auditorService.getExportExcel(surveyId, complianceData));
    // console.log(excelRes, 'worksheet');
    const toConvert = excelRes.result; //supply your full plain string here
    const file = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${toConvert}`;
    // setTimeout(() => {
    fileSaverSave.saveAs(file, excelRes?.fileName);
    // }, 1300);
  }

  TabSelectionChange(index: number) {
    this.recordingTab.forEach(tab => {
      if (tab.index == index) {
        tab.isSelected = true;
        this.selectedTab = tab.name;
      } else {
        tab.isSelected = false;
      }
    });
  } 
  private buildSubmittedSurveyList(): any[] {
    const source = (this.filteredAuditArray?.length ? this.filteredAuditArray : this.auditData) || [];
    const flattened = source.flatMap((def: any) =>
      (def.Surveys || []).map((s: any) => ({
        ...s,
        __FormName: def?.Name,
        SurveyDefinitionID: s?.SurveyDefinitionID ?? def?.SurveyDefinitionID
      }))
    );
    const allowed = new Set(['submitted', 'complete', 'in progress', 'inprogress']);
    return flattened.filter(s => {
      const name = (s?.Status?.Name || '').toLowerCase().trim();
      return allowed.has(name);
    });
  }

  ngOnDestroy(): void {
    this.saveSurveyTimeout && clearTimeout(this.saveSurveyTimeout);
    this.newAuditSurveyTimeout && clearTimeout(this.newAuditSurveyTimeout);
    this.closeTaskMenuTimeout && clearTimeout(this.closeTaskMenuTimeout);
  }
}
